import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Product',
  icon: 'mdi-cube-outline',
  path: '/reports/product/',
  menuFilters: {
    $or: [
      {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
      {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    ],
  },
  children: [
    {
      path: '/reports/product/productMixDrillDown',
      name: 'Product Mix',
      meta: { id: 'mc-productMix', permission: 'mtProduct' },
      component: () => import('./ProductMix.vue'),
      ...addPermissionsToRoute(['mtProduct']),
      menuFilters: {
        $or: [
          {
            $and: [
              { countryCode: { $in: ['us', 'ca'] } },
              { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
            ],
          },
          {
            $and: [
              { countryCode: { $in: ['za'] } },
              { enterpriseClient: { $eq: 'McDonalds' } },
            ],
          },
        ],
      },
    },
    {
      path: '/reports/product/productMixTrend',
      name: 'Product Mix Trend',
      meta: { id: 'mc-productMixTrend', permission: 'mtProduct' },
      component: () => import('./ProductMixTrend.vue'),
      ...addPermissionsToRoute(['mtProduct']),
      menuFilters: {
        $or: [
          {
            $and: [
              { countryCode: { $in: ['us', 'ca'] } },
              { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
            ],
          },
          {
            $and: [
              { countryCode: { $in: ['za'] } },
              { enterpriseClient: { $eq: 'McDonalds' } },
            ],
          },
        ],
      },
    },
    {
      path: '/reports/timhortons/product/productMixDrillDown',
      name: 'Product Mix',
      component: () => import('../../standard/product/ProductMix.vue'),
      ...addPermissionsToRoute(['mtProduct']),
    },
  ],
};

export default routes;
